import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ADD_STATEMENT_OPERATION = gql`
  mutation AddStatementOperation($consultantUuid: ID!, $newStatementOperation: StatementOperationInputDto!) {
    addStatementOperation(consultantUuid: $consultantUuid, newStatementOperation: $newStatementOperation) {
      uuid
      consultantUuid
      valueDate
      operationType
      amount
      amountEur
      currency
      comment
      linkedEntityUuid
      linkedEntityPeriod
      beforeBalance
      afterBalance
      impactsOverflow
      editable
    }
  }
`;

export const useAddStatementOperation = () => {
  const [addStatementOperation, { loading, error, data }] = useMutation(ADD_STATEMENT_OPERATION);

  return {
    addStatementOperation,
    loading,
    error,
    data: data?.addStatementOperation,
  };
};

export default useAddStatementOperation;
